import { render } from "./Contracts.vue?vue&type=template&id=0a3db8e0"
import script from "./Contracts.vue?vue&type=script&lang=js"
export * from "./Contracts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/wbtank/wbtank-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__